import z from '@/lib/zod';
import {
  optionalSearchBoolean,
  optionalSearchString,
  optionalStringParam,
} from '@/lib/zod-search-params';
import { amountSearchParams } from '@/lib/filters/amount-search-params';
import { cashFlowSearchSchema } from './cashFlowSearchSchema';
import { commonSearchSchema } from './commonSearchSchema';

export const FORECAST_LAYOUT_TABS = {
  FORECAST: 'forecast',
  PLANNING: 'planning',
  RECURRENCES: 'recurrences',
  DSCR: 'dscr',
} as const;

// Note: tab is already defined in commonSearchSchema as z.string().nullish()
// We keep it as string to avoid type incompatibility with router's search reducer
export const forecastLayoutSearchSchema = cashFlowSearchSchema
  .merge(commonSearchSchema)
  .extend({
    subTab: z.string().nullish(),
    // Planning/Recurrences specific params
    categoryIds: optionalSearchString(),
    // Recurrences specific params (filter by endDate)
    endDateFrom: optionalSearchString(),
    endDateTo: optionalSearchString(),
    // Recurrences: mostra anche le serie archiviate (isActive=false)
    showArchived: optionalSearchBoolean(),
    // Planning specific params (filter by scheduledDate)
    dateFrom: optionalSearchString(),
    dateTo: optionalSearchString(),
    // Duplicate occurrence
    duplicateFromId: z.string().nullish(),
    // Pannello Filtri di pianificazione e ricorrenze: importo (valore
    // assoluto), Stato (CSV: ForecastStatus o active|archived) e periodo di
    // attività delle ricorrenze (sovrapposizione a activeFrom/activeTo)
    ...amountSearchParams,
    statuses: optionalStringParam,
    // Conto della pianificazione: `accountId` è la selezione della griglia
    occurrenceAccountId: optionalSearchString(),
    activeFrom: optionalSearchString(),
    activeTo: optionalSearchString(),
  });

/**
 * Parametri azzerati a ogni cambio di tab del previsionale: ogni tab ha i
 * propri filtri. `statuses` ha valori diversi in pianificazione e ricorrenze
 * (l'API risponderebbe 400). NON si azzerano la selezione conti della griglia
 * (`accountId`, `accountScope`, `accountIds`), lo scenario e l'anno, che
 * valgono per tutto il previsionale, né categorie e importo, che hanno lo
 * stesso significato in pianificazione e ricorrenze.
 */
export const FORECAST_TAB_RESET_PARAMS = {
  subTab: null,
  search: null,
  sort: null,
  // Pianificazione (data programmata e conto)
  dateFrom: null,
  dateTo: null,
  occurrenceAccountId: null,
  // Ricorrenze (vecchio periodo su endDate, periodo di attività, archiviate)
  endDateFrom: null,
  endDateTo: null,
  activeFrom: null,
  activeTo: null,
  showArchived: null,
  statuses: null,
} as const satisfies Partial<Record<keyof ForecastLayoutSearchSchema, null>>;

export type ForecastLayoutSearchSchema = z.infer<
  typeof forecastLayoutSearchSchema
>;
